<p-toast></p-toast>
<router-outlet></router-outlet>

@if (loading()) {
  <div class="customProgressSpinner">
    <p-progress-spinner></p-progress-spinner>
  </div>
}
